"use strict";

angular.module("app").directive("addressAnalyze", [
	"FitiSubscriptionService", "Utils", "LeafletService",
	function (FitiSubscriptionService, Utils, LeafletService) {
	return {
		restrict: "E",
		templateUrl: "common/directives/school-iti/address/addressAnalyze.html",
		replace: false,
		isolated: false,
		link: function (scope) {

			scope.data.analyzeAddress.loading = true;
			scope.data.specifyOtherAddress = false;

			function searchAddress() {
				var searchAddress = scope.data.analyzeAddress.address + " " + scope.data.analyzeAddress.zipCode + " " + scope.data.analyzeAddress.city;
				FitiSubscriptionService.getAddress(searchAddress).then((response) => {
					const data = response.data;
					let listAddressTemp = [];
					for (let i = 0; i < data.features.length; i++) {
						let feature = data.features[i];
						listAddressTemp.push({
							longitude: feature.geometry.coordinates[0],
							latitude: feature.geometry.coordinates[1],
							label: feature.properties.label,
							address: feature.properties.name,
							city: feature.properties.city,
							zipCode: feature.properties.postcode,
							insee: feature.properties.citycode,
							exact: true
						});
					}

					// on regarde s'il faut limiter à certaines villes
					let listAddress = [];
					if (scope.data.listCitiesAuthorized !== undefined) {
						for (let i = 0; i < listAddressTemp.length; i++) {
							let address = listAddressTemp[i];
							if (existInCitiesModel(address.insee)) {
								listAddress.push(address);
							}
						}
					} else {
						listAddress = listAddressTemp;
					}
					scope.data.analyzeAddress.listAddress = listAddress;

					// Rajouter le choix manuel
					let analyzeAddress = scope.data.analyzeAddress;
					listAddress.push({
						longitude: 0,
						latitude: 0,
						label: analyzeAddress.address + " " + analyzeAddress.zipCode + " " + analyzeAddress.city,
						address: analyzeAddress.address,
						city: analyzeAddress.city,
						zipCode: analyzeAddress.zipCode,
						insee: undefined,
						exact: false
					});

					// On recherche si un résultat est strictement identique à l'adresse saisie par l'utilisateur
					initSelectionAddress(listAddress);
					scope.toggleAddress();

					scope.data.analyzeAddress.loading = false;
				}).catch(function (data) {
					Utils.makeErrorMessage(data, "Problème lors la recherche de l'adresse");
				});
			}

			/**
			 * On recherche une adresse équivalente dans la liste remontée par le service
			 * On test zipCode/city/address avec sanitize des strings (st/saint -/"")
			 *
			 * @param listAddress
			 */
			function initSelectionAddress(listAddress) {
				let analyzeAddress = scope.data.analyzeAddress;
				for (let res in listAddress) {
					let address = listAddress[res];
					if (address.zipCode !== analyzeAddress.zipCode) {
						continue;
					}
					if (Utils.sanitizeAddress(address.city) !== Utils.sanitizeAddress(analyzeAddress.city)) {
						continue;
					}
					if (Utils.sanitizeAddress(address.address) !== Utils.sanitizeAddress(analyzeAddress.address)) {
						continue;
					}
					scope.data.analyzeAddress.selectedAddress = address;
					return;
				}

				// Si on n'a pas trouvé d'équivalence on sélectionne la dernière
				scope.data.analyzeAddress.selectedAddress = listAddress[listAddress.length - 1];
			}

			searchAddress();

			function existInCitiesModel(insee) {
				for (let i = 0; i < scope.data.listCitiesAuthorized.length; i++) {
					let oneCity = scope.data.listCitiesAuthorized[i];
					if (oneCity.city.insee === insee) {
						return true;
					}
				}
				return false;
			}

			/**
			 * Click sur une addresse on cache la map si elle est affichée
			 */
			scope.toggleAddress = function () {
				let listAddress = scope.data.analyzeAddress.listAddress;
				scope.data.specifyOtherAddress = scope.data.analyzeAddress.selectedAddress === listAddress[listAddress.length - 1];
			};

			/**
			 * Sauvegarde des coordonnées dans l'adresse sélectionnée
			 *
			 * @param coordinates
			 * @param isExact
			 */
			scope.saveAddressGeoloc = function (coordinates, isExact) {
				let listAddress = scope.data.analyzeAddress.listAddress;
				scope.data.analyzeAddress.selectedAddress = listAddress[listAddress.length - 1];
				scope.data.analyzeAddress.selectedAddress.longitude = coordinates.longitude;
				scope.data.analyzeAddress.selectedAddress.latitude = coordinates.latitude;
				scope.data.analyzeAddress.selectedAddress.exact = isExact;
			};

		}

	};
}])
;
